import { useState } from 'react';

const useDataState = () => {
    const [characters, setCharacters] = useState([]);
    const [allCards, setAllCards] = useState([]);
    const [allStats, setAllStats] = useState([]);
    const [allAptitudes, setAllAptitudes] = useState([]);
    const [allSkills, setAllSkills] = useState([]);

    return {
        characters, setCharacters,
        allCards, setAllCards,
        allStats, setAllStats,
        allAptitudes, setAllAptitudes,
        allSkills, setAllSkills
    };
};

export default useDataState;
// Revisado: 2025-12-16
